export default __webpack_public_path__ + "static/media/mobile-photo-11.50c68403.jpg";